import { render, staticRenderFns } from "./treasury_un.vue?vue&type=template&id=169e5bf4&"
import script from "./treasury_un.vue?vue&type=script&lang=js&"
export * from "./treasury_un.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports